import { Image, useComputedColorScheme } from "@mantine/core";

export default function BrandLogo({ brand, size = 64 }) {
  const colorScheme = useComputedColorScheme();
  const url = typeof brand === "string" ? brand : brand.websiteUrl;
  const urlWithoutProtocol = url?.replace(/(^\w+:|^)\/\//, "");

  if (!brand.logoUrl && !urlWithoutProtocol) {
    return null; // or return a placeholder image
  }

  const imageSource =
    brand.logoUrl ||
    `https://img.logo.dev/${urlWithoutProtocol}?theme=${colorScheme}&format=png&token=pk_BRVztjhBQKShTbUQQs6vHA&size=${size}`;

  return <Image radius="sm" w={size} src={imageSource} alt={brand.name} />;
}
